import { api } from "../api";

/**
 * findAllTimezoneListResponse - Function that finds on database all timezones as select list response   
 * /timezones  
 * method GET 
 * @async-function
 */
const findAllTimezoneListResponse = async (token: string) => {
    const response = await api.get(
        `/timezones`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllTimezoneListResponse;